// =============================================================================
//  Copyright : 2021 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : upload hooks
// =============================================================================
// ---Third-party imports

// ---Framework imports
import {Actions, Sel} from 'uix/registries'
import {dict} from 'ldash'
import log from 'uix/logging'
import {useActions, useCallback, useState, useSelector, useMemo} from 'uix/hooks'

// ---Local imports
import * as UploadActions from './actions'

// ---Exports

export const useUpload = () => {
  let {uploadFile} = useActions(UploadActions)
  let uploads = useSelector(Sel.uploads)
  let [uploadQueue, setUploadQueue] = useState([])

  let uploadFiles = useCallback(files => {
    files.forEach(f => uploadFile(f.path, f.bytes))
    setUploadQueue(files)
  })

  let uploaded_done = useMemo(
    () => uploadQueue.filter(f => uploads[f.path]?.state == 'upload done'),
    [uploads, uploadQueue]
  )
  let uploaded_count = uploaded_done.length

  let progress = useMemo(() => {
    let q = uploadQueue.filter(f => uploads[f.path])
    return {total: q.length, step: uploaded_count, running: uploaded_count < q.length}
  }, [uploadQueue, uploaded_count])

  let activeUploads = uploadQueue
    .filter(f => uploads[f.path]?.state == 'upload chunk')
    .map(f => ({...uploads[f.path], fpath: f.path}))
  progress = useMemo(() => ({...progress, activeUploads}), [progress, activeUploads[0]?.chunk])

  //~ mapItems(uploads, (path, data) => [path])
  let uploaded = useMemo(
    () => dict(uploaded_done.map(({path}) => [path, uploads[path]?.uploadid])),
    [uploaded_done, uploads]
  )
  return {uploadFiles, progress, uploaded}
}
